/**
 * initials — deterministic 2-char initials + colour for a user identity.
 *
 * Used by <InitialsAvatar /> in topbar, profile, user list, etc.
 */

const PALETTE = [
  { bg: "#0E3D2F", fg: "#FFF8EC" },
  { bg: "#7C3F00", fg: "#FFF8EC" },
  { bg: "#5C3317", fg: "#FFF8EC" },
  { bg: "#1F4E5F", fg: "#FFF8EC" },
  { bg: "#6B2D5C", fg: "#FFF8EC" },
  { bg: "#2D5016", fg: "#FFF8EC" },
  { bg: "#8B3A3A", fg: "#FFF8EC" },
  { bg: "#3F4B83", fg: "#FFF8EC" },
];

function hashCode(input) {
  const s = String(input ?? "");
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function initialsFor({ firstName, lastName, name, email } = {}) {
  const first = (firstName || "").trim();
  const last = (lastName || "").trim();
  if (first || last) {
    const a = first[0] || "";
    const b = last[0] || "";
    return (a + b).toUpperCase() || "?";
  }
  if (name && name.trim()) {
    const parts = name.trim().split(/\s+/);
    const a = parts[0]?.[0] || "";
    const b = parts[1]?.[0] || "";
    return (a + b || a || "?").toUpperCase();
  }
  if (email && email.includes("@")) {
    return email.slice(0, 2).toUpperCase();
  }
  return "?";
}

export function colourFor({ id, email, name } = {}) {
  const key = id != null ? `id:${id}` : email || name || "anon";
  const idx = hashCode(key) % PALETTE.length;
  return PALETTE[idx];
}
